"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * We mostly use this event for merging order items to order and to save order ids which were merged to this orders
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a, _b, _c, _d, _e;
    let order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    // if the order id is already merged into this order, then skip this action
    if (((_a = event === null || event === void 0 ? void 0 : event.orderIdsToMerge) === null || _a === void 0 ? void 0 : _a.length) &&
        event.orderIdsToMerge.some(orderId => (order.ordersMerged || []).includes(orderId))) {
        return order;
    }
    const existingAdjustmentIds = (_b = order.adjustments) === null || _b === void 0 ? void 0 : _b.map(a => a.id);
    const orderItemsToAdd = event.itemMergeOptions.orderItems;
    const orderPaymentsToAdd = event.itemMergeOptions.payments;
    // Remove duplicate adjustments when merging tables
    const orderAdjustmentsToAdd = (_c = event.itemMergeOptions.adjustments) === null || _c === void 0 ? void 0 : _c.filter(adjToMerge => {
        var _a;
        if (adjToMerge.id === domain_1.CUSTOM_ADJUSTMENT_ID &&
            ((_a = order.adjustments) === null || _a === void 0 ? void 0 : _a.find(a => a.id === domain_1.CUSTOM_ADJUSTMENT_ID &&
                a.adjustmentType === adjToMerge.adjustmentType &&
                a.adjustmentUnit === adjToMerge.adjustmentUnit &&
                a.amount === adjToMerge.amount))) {
            return false;
        }
        else if (adjToMerge.id !== domain_1.CUSTOM_ADJUSTMENT_ID &&
            (existingAdjustmentIds === null || existingAdjustmentIds === void 0 ? void 0 : existingAdjustmentIds.includes(adjToMerge.id))) {
            return false;
        }
        else {
            return true;
        }
    });
    if (orderItemsToAdd === null || orderItemsToAdd === void 0 ? void 0 : orderItemsToAdd.length) {
        order.orderItems = [...order.orderItems, ...orderItemsToAdd];
    }
    if ((_d = event === null || event === void 0 ? void 0 : event.orderIdsToMerge) === null || _d === void 0 ? void 0 : _d.length) {
        order.ordersMerged = event === null || event === void 0 ? void 0 : event.orderIdsToMerge;
    }
    if (orderPaymentsToAdd === null || orderPaymentsToAdd === void 0 ? void 0 : orderPaymentsToAdd.length) {
        order.payments = [...order.payments, ...orderPaymentsToAdd];
    }
    if (orderAdjustmentsToAdd === null || orderAdjustmentsToAdd === void 0 ? void 0 : orderAdjustmentsToAdd.length) {
        order.adjustments = [
            ...((_e = order.adjustments) !== null && _e !== void 0 ? _e : []),
            ...(orderAdjustmentsToAdd !== null && orderAdjustmentsToAdd !== void 0 ? orderAdjustmentsToAdd : []),
        ];
    }
    order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
    return order;
}
exports.default = default_1;
//# sourceMappingURL=initiateMerge.js.map